import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { ComponentSync, LL_V_L } from '@nu-art/thunderstorm-frontend';
import { asArray } from '@nu-art/ts-common';
import { ModuleFE_AdvisorWizard } from '../../../../../_entity/wizard/ModuleFE_AdvisorWizard.js';
import './Renderer_AdvisorWizardHeader.scss';
export class Renderer_AdvisorWizardHeader extends ComponentSync {
    __onAdvisorWizardsUpdated = (...params) => {
        if (!this.mounted)
            return;
        const currentId = this.state.wizard?._id;
        const items = asArray(params[1]);
        const updated = items.find(item => item._id === currentId);
        if (updated)
            this.setState({ wizard: updated });
    };
    deriveStateFromProps(nextProps, state) {
        state.renderArgs = nextProps.renderArgs;
        if (state.renderArgs.itemId !== state.wizard?._id)
            state.wizard = ModuleFE_AdvisorWizard.cache.unique(state.renderArgs.itemId);
        return state;
    }
    render() {
        return _jsxs(LL_V_L, { className: 'advisor-wizard-header', children: [this.render_Title(), this.render_Subtitle()] });
    }
    render_Title = () => {
        return _jsx("div", { className: 'advisor-wizard-header__title', children: this.state.wizard?.label ?? 'N/A' });
    };
    render_Subtitle = () => {
        const wizard = this.state.wizard;
        const stepCount = wizard?.steps?.length ?? 0;
        if (!stepCount)
            return;
        return _jsxs("span", { className: 'advisor-wizard-header__sub-title', children: [stepCount, " step", stepCount !== 1 ? 's' : ''] });
    };
}
//# sourceMappingURL=Renderer_AdvisorWizardHeader.js.map